import {
  Avatar,
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
  VStack
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { BsBellFill, BsWallet } from "react-icons/bs";
import { MdEmail, MdKeyboardArrowDown, MdPhone } from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom";
import naptinlogo from "../../img/naptinlogo.png";
import { IUser } from "../../models/auth.model";
import routes from "../../pages/routes";
import {
  destroyUserSession,
  getLocalUserProfile,
  getUserWallet,
} from "../../services/auth.service";
import UserNotificationsModal from "./UserNotifications";
// import WalletHistoryModal from "../trainee/WalletHistory";
import { HamburgerIcon } from "@chakra-ui/icons";
import courseRoutes from "../../pages/courses/courseRoutes";

const DashboardHeader = () => {
  const [userProfile, setUserProfile] = useState<IUser | null>();
  const [userWallet, setUserWallet] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  const drawerDisClosure = useDisclosure();
  const [isOpenWallet, setIsOpenWallet] = useState(false);
  const [wallet, setwallet] = useState(false);
  const router = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const user = getLocalUserProfile();
    setUserProfile(user);
    if (user) {
      getUserWallet(user.uuid).then((res) => {
        if (res) {
          setwallet(true);
          setUserWallet(res);
        }
      });
    }
  }, [wallet]);

  const handleLogout = () => {
    destroyUserSession();
    router("/");
  };

  const activeLink = (link: string) => {
    const style = {
      borderColor: "white",
      borderBottom: "",
    };

    if (link === location.pathname) {
      style.borderColor = "#EC3337";
      style.borderBottom = "2px Solid";
    }

    return style;
  };
  return (
    <Box>
      <Flex
        height="45px"
        bg="#FFFFFF"
        borderBottom="0.3px solid"
        borderColor="gray.200"
        direction="row"
        px={["12px", "14px"]}
        alignItems="center"
        justifyContent="space-between"
      >
        <Flex alignItems="center">
          <Box as="span">
            <Box color="#EC3337" fontWeight="600" fontSize="12px">
              <Link to={routes.LandingPage}>Main Page</Link>
            </Box>
          </Box>
        </Flex>
        <Flex
          alignItems="center"
          height="inherit"
          color="#616161"
          fontSize="12px"
          lineHeight="16px"
          display={{ lg: "flex", md: "flex", sm: "none", base: "none" }}
        >
          <HStack>
            <MdPhone />
            <Text>
              08060844971, 08033543304, 07067777559 [9:00AM - 5:00PM] |
            </Text>
          </HStack>
          <HStack ml={2}>
            <MdEmail />
            <Text>support@naptinportal.com</Text>
          </HStack>
        </Flex>
      </Flex>

      <Box px={"10px"}>
        <Flex
          height="45px"
          bg="#FFFFFF"
          color="#616161"
          direction="row"
          mt="15px"
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex alignItems="center">
            <Box as="span" width="100px" mr="10px">
              <Image src={naptinlogo} height="45px" />
            </Box>
          </Flex>

          <HStack
            spacing={["20px", "30px", "30px", "50px"]}
            color="#616161"
            fontSize={["12px", "12px", "12px", "14px"]}
            display={{ lg: "flex", md: "flex", sm: "none", base: "none" }}
          >
            <Box
              borderBottom={activeLink(routes.Dashboard).borderBottom}
              borderColor={activeLink(routes.Dashboard).borderColor}
              fontWeight="600"
              fontSize={["12px", "12px", "12px", "14px"]}
            >
              <Link to={routes.Dashboard}>Dashboard</Link>
            </Box>
            <Box
              borderBottom={activeLink(routes.Courses).borderBottom}
              borderColor={activeLink(routes.Courses).borderColor}
              fontWeight="600"
              fontSize={["12px", "12px", "12px", "14px"]}
            >
              <Link to={routes.Courses}>Courses</Link>
            </Box>
            <Box
              borderBottom={activeLink(routes.Application).borderBottom}
              borderColor={activeLink(routes.Application).borderColor}
              lineHeight={5}
              fontWeight="600"
              fontSize={["12px", "12px", "12px", "14px"]}
            >
              <Link to={routes.Application}> My Application </Link>
            </Box>

            {/* <Box borderBottom={activeLink(routes.Survey).borderBottom} borderColor={activeLink(routes.Survey).borderColor} lineHeight={5} fontWeight='600' fontSize={['12px', '12px', '12px', '14px']} >
                            <Link to={routes.Survey}> Survey </Link>
                        </Box> */}
            <Box
              borderBottom={activeLink(courseRoutes.DuePayment).borderBottom}
              borderColor={activeLink(courseRoutes.DuePayment).borderColor}
              lineHeight={5}
              fontWeight="600"
              fontSize={["12px", "12px", "12px", "14px"]}
            >
              <Link to={courseRoutes.DuePayment}> Payment </Link>
            </Box>
            <Box
              borderBottom={activeLink(routes.Result).borderBottom}
              borderColor={activeLink(routes.Result).borderColor}
              lineHeight={5}
              fontWeight="600"
              fontSize={["12px", "12px", "12px", "14px"]}
            >
              <Link to={routes.Result}> Check Result </Link>
            </Box>
          </HStack>

          <Drawer
            onClose={drawerDisClosure.onClose}
            isOpen={drawerDisClosure.isOpen}
          >
            <DrawerOverlay />
            <DrawerContent>
              <DrawerBody>
                <VStack
                  spacing={{ lg: "70", md: "25", sm: "25", base: "25" }}
                  color="#616161"
                  fontSize="14px"
                  display={{
                    lg: "none",
                    md: "flex",
                    sm: "flex",
                    base: "flex",
                  }}
                  justifyContent={"flex-start"}
                  width={"100%"}
                >
                  <Box
                    borderBottom={activeLink(routes.Dashboard).borderBottom}
                    borderColor={activeLink(routes.Dashboard).borderColor}
                    fontWeight="600"
                    fontSize={["12px", "12px", "12px", "14px"]}
                  >
                    <Link to={routes.Dashboard}>Dashboard</Link>
                  </Box>
                  <Box
                    borderBottom={activeLink(routes.Courses).borderBottom}
                    borderColor={activeLink(routes.Courses).borderColor}
                    fontWeight="600"
                    fontSize={["12px", "12px", "12px", "14px"]}
                  >
                    <Link to={routes.Courses}>Courses</Link>
                  </Box>
                  <Box
                    borderBottom={activeLink(routes.Application).borderBottom}
                    borderColor={activeLink(routes.Application).borderColor}
                    lineHeight={5}
                    fontWeight="600"
                    fontSize={["12px", "12px", "12px", "14px"]}
                  >
                    <Link to={routes.Application}> My Application </Link>
                  </Box>

                  {/* <Box borderBottom={activeLink(routes.Survey).borderBottom} borderColor={activeLink(routes.Survey).borderColor} lineHeight={5} fontWeight='600' fontSize={['12px', '12px', '12px', '14px']} >
                            <Link to={routes.Survey}> Survey </Link>
                        </Box> */}
                  <Box
                    borderBottom={
                      activeLink(courseRoutes.DuePayment).borderBottom
                    }
                    borderColor={
                      activeLink(courseRoutes.DuePayment).borderColor
                    }
                    lineHeight={5}
                    fontWeight="600"
                    fontSize={["12px", "12px", "12px", "14px"]}
                  >
                    <Link to={courseRoutes.DuePayment}> Payment </Link>
                  </Box>
                  <Box
                    borderBottom={activeLink(routes.Result).borderBottom}
                    borderColor={activeLink(routes.Result).borderColor}
                    lineHeight={5}
                    fontWeight="600"
                    fontSize={["12px", "12px", "12px", "14px"]}
                  >
                    <Link to={routes.Result}> Check Result </Link>
                  </Box>
                </VStack>
              </DrawerBody>
            </DrawerContent>
          </Drawer>

          <HStack spacing={["4px", "6px", "10px", "15px"]}>
            <IconButton
              variant="ghost"
              aria-label="bell"
              color="brand.2"
              borderRadius={20}
              onClick={() => setIsOpen(true)}
              icon={<BsBellFill />}
            />

            <Avatar size="sm" name={userProfile ? userProfile.name : "nil"} />

            <Menu>
              <MenuButton>
                <HStack color="brand.subtitle" fontSize={13}>
                  <Flex direction="column" alignItems="flex-end">
                    <Text whiteSpace="nowrap" fontWeight={"600"} hidden>
                      {" "}
                      {userProfile?.name}{" "}
                    </Text>
                  </Flex>
                  <MdKeyboardArrowDown />
                </HStack>
              </MenuButton>
              <MenuList
                fontSize={13}
                fontWeight="600"
                borderRadius={0}
                color="brand.bodyText"
              >
                <MenuItem onClick={() => router(routes.Dashboard)}>
                  Go to dashboard
                </MenuItem>
                <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
              </MenuList>
            </Menu>
            <Menu>
              <MenuButton>
                <HStack>
                  <BsWallet />
                  <Text fontSize="12px" fontWeight="600">
                    {userWallet
                      ? userWallet.available_balance
                        ? userWallet.available_balance
                        : "nil"
                      : "nil"}
                  </Text>
                </HStack>
              </MenuButton>
              <MenuList
                // width={"200px"}
                fontSize={13}
                fontWeight="600"
                borderRadius={0}
                color="brand.bodyText"
              >
                <MenuItem onClick={() => router(routes.FundWallet)}>
                  Fund Wallet
                </MenuItem>
                <MenuItem onClick={() => router(routes.WalletHistory)}>
                  View Payment History
                </MenuItem>
              </MenuList>
            </Menu>
            <HamburgerIcon
              bg="#FFFAFA"
              fontSize={"14px"}
              width="auto"
              height={["25px","35px"]}
              borderRadius={"2px"}
              onClick={drawerDisClosure.onOpen}
              display={{ lg: "none", md: "none", sm: "block", base: "block" }}
            />
          </HStack>
        </Flex>
      </Box>
      {isOpen && <UserNotificationsModal setIsOpen={setIsOpen} />}
      {/* {isOpenWallet && <WalletHistoryModal setIsOpenWallet={setIsOpenWallet} />} */}
    </Box>
  );
};

export default DashboardHeader;
